import { useState } from 'react';
import axios from 'axios';

export const useDocuments = (projectId) => {
  // Document management state
  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [uploadingDocument, setUploadingDocument] = useState(false);
  const [documentError, setDocumentError] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showDocuments, setShowDocuments] = useState(false);
  const [documentCategory, setDocumentCategory] = useState('other');
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [deleteDocumentModalOpen, setDeleteDocumentModalOpen] = useState(false);

  const fetchDocuments = async () => {
    setDocumentsLoading(true);
    setDocumentError('');
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/projects/${projectId}/documents`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDocuments(response.data.documents || []);
    } catch (error) {
      console.error('Error fetching documents:', error);
      setDocumentError('Failed to load documents');
    } finally {
      setDocumentsLoading(false);
    }
  };

  const handleDocumentUpload = async (files) => {
    if (!files || files.length === 0) return;

    setUploadingDocument(true);
    setDocumentError('');

    try {
      const token = localStorage.getItem('token');
      
      for (const file of files) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('category', documentCategory);

        await axios.post(
          `${process.env.REACT_APP_API_URL}/projects/${projectId}/documents/upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
      }

      // Refresh documents list
      await fetchDocuments();
      setSelectedFiles([]);
    } catch (error) {
      console.error('Error uploading document:', error);
      setDocumentError(error.response?.data?.error || 'Failed to upload document');
    } finally {
      setUploadingDocument(false);
    }
  };

  const handleDeleteDocument = async (documentId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/projects/${projectId}/documents/${documentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Remove from local state
      setDocuments(prev => prev.filter(doc => doc.id !== documentId));
      setDeleteDocumentModalOpen(false);
      setDocumentToDelete(null);
    } catch (error) {
      console.error('Error deleting document:', error);
      setDocumentError('Failed to delete document');
    }
  };

  return {
    documents,
    documentsLoading,
    uploadingDocument,
    documentError,
    selectedFiles,
    showDocuments,
    documentCategory,
    documentToDelete,
    deleteDocumentModalOpen,
    fetchDocuments,
    handleDocumentUpload,
    handleDeleteDocument,
    setDocuments,
    setDocumentError,
    setSelectedFiles,
    setShowDocuments,
    setDocumentCategory,
    setDocumentToDelete,
    setDeleteDocumentModalOpen
  };
}; 